module.exports = __webpack_public_path__ + "static/media/Marston Ave, San Francisco, CA2.dd88a311.jpg";